export enum EnumOrganizationMemberPermissions {
  FullAccess = 'organization_member_full_access',

  // User Portal
  AccessCourses = 'organization_member_access_courses',
  AccessCommunities = 'organization_member_access_communities',
  AccessEvents = 'organization_member_access_events',
  AccessSkillsDevelopment = 'organization_member_access_skills_development',
  AccessCoaching = 'organization_member_access_coaching',
  AccessExternalCourses = 'organization_member_access_external_courses',
  TakeSocialEventAttendance = 'organization_member_take_social_event_attendance',

  // Instructor Portal
  CreateCourses = 'organization_member_create_courses',
  ImportCourses = 'organization_member_import_courses',

  // Coach Portal
  CoachingAbility = 'organization_member_coaching_ability',
  CoachPricingUpdateAuthorization = 'organization_member_coach_pricing_update_authorization',

  // Dashboard — Users
  ViewUsers = 'organization_member_view_users',
  ModifyUsers = 'organization_member_modify_users',
  ViewUsersActivity = 'organization_member_view_users_activity',
  ViewUsersTransactions = 'organization_member_view_member_transactions',

  // Dashboard — Member Roles
  ViewMemberRoles = 'organization_member_view_member_roles',
  ModifyMemberRoles = 'organization_member_modify_member_roles',

  // Dashboard — Courses
  ViewCourses = 'organization_member_view_courses',
  ModifyCourses = 'organization_member_modify_courses',
  ModifyCoursesPrice = 'organization_member_modify_courses_price',
  ModifyCoursesDates = 'organization_member_modify_courses_dates',
  ModifyCoursesInstructors = 'organization_member_modify_courses_instructors',
  ModifyCoursesStudents = 'organization_member_modify_courses_students',
  ViewImportedCourses = 'organization_member_view_imported_courses',
  ModifyImportedCourses = 'organization_member_modify_imported_courses',
  ViewExternalCourses = 'organization_member_view_external_courses',
  ModifyExternalCourses = 'organization_member_modify_external_courses',

  // Dashboard — Specializations
  ViewSpecializations = 'organization_member_view_specializations',
  ModifySpecializations = 'organization_member_modify_specializations',
  ModifySpecializationCourses = 'organization_member_modify_specialization_courses',

  // Dashboard — Financials
  ViewSales = 'organization_member_view_sales',
  ViewRefunds = 'organization_member_view_refunds',
  IssueRefunds = 'organization_member_issue_refunds',

  // Dashboard — Social Events
  ViewEvents = 'organization_member_view_events',
  ModifyEvents = 'organization_member_modify_events',
  ModifyEventsAttendance = 'organization_member_modify_events_attendance',

  // Dashboard — Communities
  ViewCommunities = 'organization_member_view_communities',
  ModifyCommunities = 'organization_member_modify_communities',
  ModifyCommunityMembers = 'organization_member_modify_community_members',

  // Dashboard — Skills Development
  ReadSkillsDevelopment = 'organization_member_read_skills_development',
  ModifySkillsDevelopment = 'organization_member_modify_skills_development',
  ModifySkillsDevelopmentMembers = 'organization_member_modify_skills_development_members',
  // KP-61: department manager scope — unlocks ONLY the manager-scoped
  // department reads (my-managed-departments / members-progress).
  ManageDepartment = 'organization_member_manage_department',

  // Dashboard — Support Team
  ViewSupportTeams = 'organization_member_view_support_teams',
  ModifySupportTeams = 'organization_member_modify_support_teams',

  // Dashboard — Organization Configuration
  ViewOrganizationNewsletter = 'organization_member_view_organization_newsletter',
  ViewOrganizationConfiguration = 'organization_member_view_organization_configuration',
  ModifyOrganizationConfiguration = 'organization_member_modify_organization_configuration',

  // Dashboard — Coaching
  ViewCoaches = 'organization_member_read_coaches',
  ModifyCoaches = 'organization_member_modify_coaches',

  // Dashboard — Wallet
  ViewWallet = 'organization_member_view_wallet',
  ModifyWallet = 'organization_member_modify_wallet',
  ModifyConversionRate = 'organization_member_modify_conversion_rate',
  ViewConversionRate = 'organization_member_view_conversion_rate',

  // Dashboard — Assessments
  ViewAssessments = 'organization_member_view_assessments',
  ModifyAssessments = 'organization_member_modify_assessments',

  // Dashboard — Dynamic Pages
  ViewDynamicPages = 'organization_member_view_dynamic_pages',
  ModifyDynamicPages = 'organization_member_modify_dynamic_pages',

  // Corporate Accounts
  ViewCorporatePortal = 'organization_member_view_corporate_portal',
  InviteCorporateParticipants = 'organization_member_invite_corporate_participants',
  ViewCorporateEnrollments = 'organization_member_view_corporate_enrollments',
  ViewCorporateAccounts = 'organization_member_view_corporate_accounts',
  ModifyCorporateAccounts = 'organization_member_modify_corporate_accounts',
}

export enum EnumOrgPermission {
  Default = 'organization_member_default_11',
  Admin = 'organization_member_admin_11',
  Coach = 'organization_member_coach_11',
  Instructor = 'organization_member_instructor_11',
}

export enum EnumOrganizationPermissions {
  Everything = 'organization_everything',
  Enabled = 'organization_enabled',
  RegistrationEnabled = 'organization_registration_enabled',
  SelfRegistration = 'organization_self_registration',
  SelfEnrollment = 'organization_self_enrollment',
  LMS = 'organization_lms',
  Coaching = 'organization_coaching',
  SocialPlatform = 'organization_social_platform',
  SocialEvents = 'organization_social_events',
  LearningPath = 'organization_learning_path',
  CRUDCourses = 'organization_crud_courses',
  CRUDMembers = 'organization_crud_members',
  CRUDSpecializations = 'organization_crud_specializations',
  CRUDSocialGroups = 'organization_crud_social_groups',
  CRUDSocialEvents = 'organization_crud_social_events',
  CRUDLearningPaths = 'organization_crud_learning_paths',
  CRUDChecklists = 'organization_crud_checklists',
  CRUDSupportTeams = 'organization_crud_support_teams',
  CorporateAccounts = 'organization_corporate_accounts',
  Wallet = 'organization_wallet',
  Marketplace = 'organization_marketplace',
  Assessment = 'organization_assessment',
  DynamicPages = 'organization_dynamic_pages',
}

export enum EnumUserPermissions {
  Everything = 'user_everything',
  CRUDOrganizations = 'user_crud_organizations',
  CRUDPermissionSets = 'user_crud_permission_sets',
  ModifyCache = 'user_modify_cache',
  ModifySettings = 'user_modify_settings',
  ModifyMigrations = 'user_modify_migrations',
  AccessControlBase = 'user_access_control_base',
}

export enum EnumPermissionContextIds {
  Global = 1,
  User = 2,
  Organization = 3,
  OrganizationMember = 4,
  CourseInstructor = 5,
}

export enum EnumPermissionContexts {
  Global = 'global',
  User = 'user',
  Organization = 'organization',
  OrganizationMember = 'organization_member',
  CourseInstructor = 'course_instructor',
}
